module.exports = __webpack_public_path__ + "img/qrcode.dd65b16a.jpg";